<template>
    <div class="flex items-center">
        <img src="/api/images/PressKit/logo_white.webp" fetchpriority="high" decoding="async" alt="logo" class="block max-[320px]:hidden mt-3 max-[320px]:w-24 w-48 sm:w-96" />
        <img src="/api/images/PressKit/mug.webp" fetchpriority="high" decoding="async" alt="mug" class="hidden max-[320px]:block mt-3 w-14" />
    </div>
</template>
